<ra-modal [title]="'shared.modalListOrders.title' | translate" [size]="'large'" (close)="close.emit()">
    @if (loading()) {
        <div class="container-loading">
            <ra-loading [message]="'shared.modalListOrders.loading' | translate"/>
        </div>
    }
    @else {
        <!-- Message -->
        <p class="ra-label-s content-secondary description-message">{{ message() || ('shared.modalListOrders.hint' | translate) }}</p>

        <!-- Input search -->
        <div class="container-input-search">
            <ra-input
                [placeholder]="'shared.modalListOrders.searchPlaceholder' | translate"
                [formControl]="searchControl"
                [showRequiredOrOptional]="false"
            />
        </div>

        @if (orders().length === 0) {
            <div class="container-empty">
                <ra-empty [message]="'shared.modalListOrders.emptyMessage' | translate"/>
            </div>
        }
        @else {
            <!-- List -->
            <div class="container-orders-list">
                @for (order of orders(); track order._id) {
                    <ra-fillet
                        [icon]="'folder'"
                        [title]="order.client?.name || order.code"
                        [clickMessage]="'shared.modalListOrders.clickSelect' | translate"
                        [description]="order.code + (order.description ? ' · ' + order.description : '')"
                        (click)="selectOrder.emit(order)"
                    />
                }
            </div>
        }
    }
</ra-modal>
